import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import styles from './VideoMeetingsScreen.module.css';

const VideoMeetings = ({ setMode }) => {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className={styles.title}>{t('screens.video.meetings.title')}</h1>
            <p className={styles.subtitle}>{t('screens.video.meetings.subtitle')}</p>
          </div>

          <div className={styles.optionsGrid}>
            {/* Option A: Direct Call */}
            <div className={styles.option} onClick={() => setMode('direct-call')}>
              <h2 className={styles.optionTitle}>{t('screens.video.meetings.directCallTitle')}</h2>
              <p className={styles.optionDescription}>{t('screens.video.meetings.directCallDesc')}</p>
            </div>

            {/* Option B: Group Meeting */}
            <div className={styles.option} onClick={() => setMode('group-meeting')}>
              <h2 className={styles.optionTitle}>{t('screens.video.meetings.groupMeetingTitle')}</h2>
              <p className={styles.optionDescription}>{t('screens.video.meetings.groupMeetingDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default VideoMeetings;
